import { defineComponent as w, useId as L, getCurrentInstance as N, computed as P, useTemplateRef as S, createBlock as b, openBlock as s, resolveDynamicComponent as c, mergeProps as y, unref as o, withCtx as i, createVNode as h, createElementBlock as B, createCommentVNode as t, createElementVNode as V, normalizeClass as d, renderSlot as n, createTextVNode as p, toDisplayString as u } from "vue";
import a from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Radio/radio.js";
import { useOUIAProps as D } from "../helpers/ouia.js";
import T from "../helpers/Sort.vue2.js";
import A from "../helpers/SortBy.vue2.js";
import { useChildrenTracker as E } from "../use/children-tracker.js";
import { FormInputsKey as z } from "./Form/common.js";
const F = ["id", "disabled", "checked", "aria-label"], H = /* @__PURE__ */ w({
  name: "PfRadio",
  inheritAttrs: !1,
  __name: "Radio",
  props: {
    component: { default: "div" },
    id: { default: () => L() },
    labelBeforeButton: { type: Boolean },
    checked: { type: Boolean },
    disabled: { type: Boolean },
    label: {},
    ariaLabel: {},
    description: {},
    body: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["change"],
  setup(k, { expose: $, emit: v }) {
    var m;
    const r = k, g = v;
    E(z, (m = N()) == null ? void 0 : m.proxy);
    const C = D({ id: r.ouiaId, safe: r.ouiaSafe }), l = P(() => r.component === "label"), I = S("inputRef");
    return $({
      input: I
    }), (e, f) => (s(), b(c(e.component), y(o(C), {
      class: [o(a).radio, {
        [o(a).modifiers.standalone]: !l.value && !(e.label || e.$slots.label)
      }],
      for: l.value ? e.id : void 0
    }), {
      default: i(() => [
        h(T, null, {
          default: i(() => [
            h(A, {
              weight: e.labelBeforeButton ? -1 : 1
            }, {
              default: i(() => [
                e.label || e.$slots.label ? (s(), b(c(l.value ? "span" : "label"), {
                  key: 0,
                  class: d([o(a).radioLabel, {
                    [o(a).modifiers.disabled]: e.disabled
                  }]),
                  for: l.value ? void 0 : e.id
                }, {
                  default: i(() => [
                    n(e.$slots, "label", {}, () => [
                      p(u(e.label), 1)
                    ])
                  ]),
                  _: 3
                }, 8, ["class", "for"])) : t("", !0)
              ]),
              _: 3
            }, 8, ["weight"]),
            V("input", y({
              id: e.id,
              ref: "inputRef"
            }, e.$attrs, {
              type: "radio",
              class: o(a).radioInput,
              disabled: e.disabled,
              checked: e.checked,
              "aria-label": e.label || e.$slots.label ? void 0 : e.ariaLabel,
              onChange: f[0] || (f[0] = (R) => g("change", R))
            }), null, 16, F)
          ]),
          _: 3
        }),
        e.description || e.$slots.description ? (s(), B("span", {
          key: 0,
          class: d(o(a).radioDescription)
        }, [
          n(e.$slots, "description", {}, () => [
            p(u(e.description), 1)
          ])
        ], 2)) : t("", !0),
        e.body || e.$slots.default ? (s(), B("span", {
          key: 1,
          class: d(o(a).radioBody)
        }, [
          n(e.$slots, "default", {}, () => [
            p(u(e.body), 1)
          ])
        ], 2)) : t("", !0)
      ]),
      _: 3
    }, 16, ["class", "for"]));
  }
});
export {
  H as default
};
